import { DataGrid, GridColumnProps, LinkColumn, SelectMode, StatusChip, StatusType, SelectFilterComponent, SelectFloatingFilterComponent, SelectSearchFloatingFilterComponent } from '@roc/ui';

import { observer } from 'mobx-react';
import { DateFormat, formatDate } from '@roc/feature-utils';
import { Box, Grid, IconButton, ListItemIcon, ListItemText, makeStyles, Menu, MenuItem } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useTaxCertificateStore } from '../hooks/useTaxCertificateStore';
import { formatCurrency } from '@roc/ui/utils';
import { TaxTabs } from '../types/types';
import { getTaxColumns } from '../utils/utils';
import { getTaxToolbar } from './taxToolbar';
import { StatusEditorPaymentApprobal } from './statusEditorPaymentApprobal';
import { CloudDownload, MoreVert } from '@material-ui/icons';
import { useDocumentStore } from '@roc/feature-documents';
import { PaymentApprovalModal } from './paymentApprovalModal';


const useStyles = makeStyles(theme => ({
  gridContainer: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    height: '65vh',
    overflow: 'hidden',
  },
}));

export const TaxCertificateGrid = observer(() => {
  const classes = useStyles();
  const { taxCertificateStore } = useTaxCertificateStore();
  const { taxCertificateGridStore, tab, paymentAprovalSelectedFilter } = taxCertificateStore;
  const [anchorEl, setAnchorEl] = useState<HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);
  const [record, setRecord] = useState<any>({});
  const { documentStore } = useDocumentStore();

  useEffect(() => {
    taxCertificateStore.clearLoanIds();
    onTabChange();
  }, [tab]);

  const openMenu = (event: React.MouseEvent<HTMLElement>, record) => {
    setRecord(record);
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const onTabChange = () => {
    taxCertificateGridStore.resetAndFetchGridData();
  };

  const frameworkComponents = {
    statusCellRenderer: ({ value }) => value ?? null,
    selectFloatingFilter: SelectFloatingFilterComponent,
    selectSearchFloatingFilter: SelectSearchFloatingFilterComponent,
    selectFilter: SelectFilterComponent,
    taxCertificateStatusCellRenderer: ({ value }) => value ?? null,
    dateCellRenderer: ({ value }) =>
      formatDate(value, DateFormat.MMDDYYYY) ?? null,
    currencyCellRenderer({ value }) {
      return formatCurrency(value);
    },
    actionCellRenderer: params => {
      return (
        <>
          <IconButton
            onClick={e => {
              openMenu(e, params.node.data);
            }}
          >
            <MoreVert color="primary" />
          </IconButton>
        </>
      );
    },
    dropdownGridEditor: StatusEditorPaymentApprobal,
    linkColumnCellRenderer(params) {
      const row = params.node.data;
      return row?.status === 'NA' ? (
        <span> {params.value} </span>
      ) : (
        <LinkColumn
          value={params.value}
          url={'#'}
          onClick={() => {
            taxCertificateStore.openModal(row);
            console.log('openModal(row)', row);
          }}
        />
      );
    },
  };

  const onSortChanged = params => {
    const sortModel = params.api.getSortModel();
    taxCertificateGridStore.setSortModel(sortModel);
  };

  const onFilterChanged = params => {
    const filterModel = params.api.getFilterModel();
    taxCertificateGridStore.setFilterModel(filterModel);
  };

  const onRowSelected = (params) => {
    // TODO - WE SHOULD USE A TRANSACTION ID
    taxCertificateStore.setLoanIds(params?.data?.loanId, params?.node.selected);
  };

  const handleModelUpdated = (params) => {
    params.api.forEachNode((node) => {
      if (taxCertificateStore.loanIds.includes(node.data?.loanId)) {
        node.setSelected(true);
      }
    });
  };


  return (
    <Box>
      <Grid item className={classes.gridContainer}>
        <DataGrid
          columns={getTaxColumns(tab, paymentAprovalSelectedFilter)}
          rows={taxCertificateGridStore.gridData.data.rows}
          frameworkComponents={frameworkComponents}
          selectMode={tab === TaxTabs.REDEMPTION_REQUEST && SelectMode.MULTIPLE}
          headerCheckboxSelection={true}
          suppressRowClickSelection={true}
          toolbar={getTaxToolbar(tab)}
          key={tab}
          onSortChanged={onSortChanged}
          onFilterChanged={onFilterChanged}
          isLoading={taxCertificateGridStore.isLoading}
          showFilters={taxCertificateGridStore.showFilters}
          sortModel={taxCertificateGridStore.sortModel}
          filterModel={taxCertificateGridStore.filterModel}
          paginationData={taxCertificateGridStore.gridData.meta}
          setPageNumber={taxCertificateGridStore.setPageNumber}
          onRowSelected={onRowSelected}
          getRowNodeId={(data) => data.id || data.loanId}
          handleModelUpdated={handleModelUpdated}
        />
      </Grid>
      <Menu
        id="menu-appbar"
        getContentAnchorEl={null}
        anchorEl={anchorEl}
        keepMounted
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        open={menuOpen}
        onClose={handleMenuClose}
      >
        <MenuItem
          disabled={!record.documentId}
          onClick={() => {
            const document = {
              loanTaskId: record.documentId,
              originalFileName: record.originalFileName,
            };
            documentStore.downloadDocumentOriginalNameById(document);
            handleMenuClose();
          }}
        >
          <ListItemIcon>
            <CloudDownload fontSize="small" />
          </ListItemIcon>
          <ListItemText>Download File</ListItemText>
        </MenuItem>
      </Menu>
      <PaymentApprovalModal />
    </Box>
  );
});
